import React from 'react'

export const Footer = () => {
  return (
    <footer>
        <div>
            <h1>
                Xenon
            </h1>
            <p>All Rights Reserved</p>
        </div>
        <div>
            <h5>Follow Us</h5>
            <div>
                <a href="">Youtube</a>
                <a href="">Intagram</a>
                <a href="">Facebook</a>
            </div>
        </div>
    </footer>
  )
}
